// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3cazg","row":"Node_row__3_zQR","label":"Node_label__22ej4","footer":"Node_footer__2vHZC"};